import _ from 'lodash';
import angular from 'angular';

export default function FaultsViewFaultsTabDirective() {
  return {
    template: require('./faults.html'),
    transclude: true,
    restrict: 'E',
    scope: {},
    controller: FaultTableController,
    controllerAs: 'vm',
    bindToController: {
      faults: '=',
      editFault: '=?',
      copiedFault: '=?',
    },
  };

  function FaultTableController(gettextCatalog, $q, $timeout, $interval, $stateParams, faultsService) {

    'ngInject';

    var vm = this;
    var configurationId;

    vm.newFault = 1;
    vm.duplicateFaultMsg = gettextCatalog.getString("Another fault already exists with the same spn, fmi, and source. These fields must be unique.");
    vm.incompleteFaultMsg = gettextCatalog.getString("Please complete the fault or cancel it before trying to save the configuration.");
    vm.noCompletedFaultsMsg = gettextCatalog.getString("You must have at least one fault saved before trying to create a configuration.");
    vm.requiresFaultsFlag = false;
    vm.requiresFaultsMsg = gettextCatalog.getString("Unable to remove fault. You must have at least one fault.");
    vm.pagination = {
      currentPage: 1,
      itemsPerPage: 15,
      maxSize: 1,
      startFrom: startFrom
    };
    vm.selectedFaultId = null;

    //Public Functions
    vm.setSelected = setSelected;
    vm.isEditMode = isEditMode;
    vm.changeEditFault = changeEditFault;
    vm.addFault = addFault;
    vm.deleteFault = deleteFault;
    vm.saveFault = saveFault;
    vm.disableEditMode = disableEditMode;
    vm.enableEditMode = enableEditMode;
    vm.isFaultInEditMode = isFaultInEditMode;
    vm.isDuplicate = isDuplicate;

    vm.init = function () {
      configurationId = $stateParams.configurationId;
      vm.isEditPage = $stateParams.isEditPage;
      $timeout(function () {
        if (!vm.isEditPage) {
          addFault();
        }
      });
    };
    vm.init();

    //Adds a new row to the faults table
    function addFault() {
      resetFaultValidation();
      var fault = {
        isNew: true,
        type: 'J1939',
        code: {
          spn: '',
          fmi: '',
          source: ''
        },
        priority: '',
        autoClear: '',
        notifyOnReturn: ''
      };
      vm.faults.unshift(fault);
      vm.enableEditMode(fault);
      if (vm.pagination.currentPage !== 1) {
        vm.pagination.currentPage = 1;
      }
    }

    function deleteFault(fault) {
      vm.faultsForm.$submitted = true;
      vm.errorText = null;
      if (vm.faults.length > 1 && configurationId && !fault.isNew) {
        var faultId = fault.id;
        faultsService.deleteFault(configurationId, faultId)
          .then(function (response) {
            if (!response) {
              return;
            }
            var faultIndex = vm.faults.indexOf(fault);
            vm.faults.splice(faultIndex, 1);
            vm.disableEditMode();
          })
          .catch(function () {
            vm.errorText = gettextCatalog.getString("An error occurred while retrieving configuration information.");
          })
          .finally(function () {
            vm.loading = false;
          });
      } else if (vm.faults.length > 1) {
        var faultIndex = vm.faults.indexOf(fault);
        vm.faults.splice(faultIndex, 1);
        vm.disableEditMode();
        return true;
      } else {
        showRequiredFaultMsg();
        return false;
      }
    }

    function saveFault(newFault) {
      var deferred = $q.defer();
      vm.faultsForm.$submitted = true;
      resetFaultValidation();
      if (isDuplicate(newFault)) {
        deferred.reject();
      } else if (configurationId && newFault.id) {
        vm.updateError = null;
        return faultsService.updateFault(configurationId, newFault.id, newFault)
          .then(function () {
            deferred.resolve();
          })
          .catch(function () {
            vm.updateError = gettextCatalog.getString("Unable to update fault information.");
            deferred.reject();
          });
      } else if (configurationId) {
        vm.postNewFaultError = null;
        if (newFault && newFault.isNew === true) {
          delete newFault['isNew'];
        }
        return faultsService.postFault(configurationId, newFault)
          .then(function (response) {
            if (!response) {
              return;
            } else {
              newFault['id'] = response.data.id;
            }
          })
          .catch(function () {
            vm.postNewFaultError = gettextCatalog.getString("Unable to save new fault to configuration.");
            deferred.reject();
          });
      }
      //case where configuration doesnt yet exist so dont post to the server | create mode
      else {
        delete newFault['isNew'];
        deferred.resolve();
      }
      return deferred.promise;
    }

    //Is anything being edited
    function isEditMode() {
      return vm.editFault !== null && vm.editFault !== undefined;
    }

    function isNotEditMode() {
      return !isEditMode();
    }

    function enableEditMode(fault) {
      resetFaultValidation();
      if (isNotEditMode()) {
        vm.editFault = fault;
        vm.copiedFault = { ...fault };
      }
      vm.faultsForm.$setValidity("edit", false);
      vm.faultsForm.$$parentForm.$submitted = false;
    }

    function setSelected(selectedFaultId) {
      vm.selectedFaultId = selectedFaultId;
    }

    function disableEditMode() {
      vm.faultsForm.$setValidity("edit", true);
      vm.editFault = null;
    }

    function isFaultInEditMode(fault) {
      return fault === vm.editFault;
    }

    function changeEditFault(fault) {
      vm.editFault = fault;
    }

    function resetFaultValidation() {
      vm.faultsForm.$submitted = false;
    }

    function showRequiredFaultMsg() {
      vm.requiresFaultsFlag = true;
      var intervalCanceller = $interval(function () {
        vm.requiresFaultsFlag = false;
        $interval.cancel(intervalCanceller);
      }, 3000);
    }

    function isDuplicate(faultToCheck) {
      var duplicate = false;
      _.forEach(vm.faults, function (fault) {
        if (faultToCheck !== fault &&
          fault.code.spn === faultToCheck.code.spn &&
          fault.code.fmi === faultToCheck.code.fmi &&
          fault.code.source === faultToCheck.code.source) {
          duplicate = true;
        }
      });
      return duplicate;
    }

    function startFrom() {
      return (vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage;
    }
  }
}